import React from 'react';
import './PricingSheetTableGrid.scss';
import {dollarsFormatter, numberFormatter} from '../../../common/TableFormatters';
import classNames from 'classnames';

const PricingSheetTableGrid = ({data}) => {

    return (
        <div className='grid-table-container'>
            <div className='grid-table-name'>
                {data.species}
            </div>
            <div id='grid-pricing-table'>
                <div className='grid-table-header'>
                    <div>Thickness</div>
                    <div>Grade</div>
                    <div>Length</div>
                    <div>BF Available</div>
                    <div className='last'>Price / BF</div>
                </div>
                <div className='grid-table-body'>
                    {data.thicknesses.map((thickness, index) => (
                        <div key={index} className={classNames({
                            'grid-row-dark': index % 2 === 0,
                            'grid-row-light': index % 2 !== 0,
                        })}>
                            <div className='thickness-column'>{thickness.name}</div>
                            <div className='thickness-content'>
                                {thickness.grades.map((grade, index) => (
                                    <React.Fragment key={index}>
                                        <div className='grade-column'>{grade.name}</div>
                                        <div className='grade-content'>
                                            {grade.data.map((d, i) => (
                                                <div key={i} className='grade-content-row'>
                                                    <div className='length-column'>{d.length_name}</div>
                                                    <div className='bf-column'>
                                                        <div>
                                                            {numberFormatter(d.bf_available)}
                                                        </div>
                                                    </div>
                                                    <div
                                                        className='price-column'>{dollarsFormatter(d.price_per_bf)}</div>
                                                </div>
                                            ))}
                                        </div>
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PricingSheetTableGrid;




// WEBPACK FOOTER //
// ./src/containers/embeddable/pricing_sheet/PricingSheetTableGrid.js